<template>
    <div class="pd20x">
        <div class="uploadFile">
            <label for="">上传通用讲义:</label>
            <div>
                <a-upload
                    name="file"
                    :accept="'.PDF'"
                    list-type="picture"
                    @change="handleChange"
                    :customRequest="customRequestDetail"
                    :fileList='fileList'
                >
                <a-button> <a-icon type="upload" />上传通用讲义</a-button>
                </a-upload>
            </div>
        </div>
        <div class="uploadFile">
            <label for="">上传通用详情页:</label>
            <div>
                <a-upload
                    name="avatar"
                    :accept="'.jpg,.png'"
                    list-type="picture-card"
                    :customRequest="customRequest"
                    :fileList='imgList'
                >
                <img v-if="request.detail_page" :src="request.detail_page" alt="avatar" />
                <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                        上传详情页
                    </div>
                </div>
                </a-upload>
            </div>
        </div>
        <div class="uploadFile">
            <label for="">上传VIP详情页:</label>
            <div>
                <a-upload
                    name="vip_detail"
                    :accept="'.jpg,.png'"
                    list-type="picture-card"
                    :customRequest="customVipDetailRequest"
                    :fileList='vipImgList'
                >
                <img v-if="request.vip_detail_page" :src="request.vip_detail_page" alt="vip-detail" />
                <div v-else>
                    <a-icon :type="vipLoading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                        上传VIP详情页
                    </div>
                </div>
                </a-upload>
            </div>
        </div>
        <div class="uploadFile">
            <label>用户协议:</label>
            <div>
                <Editor
                    :value="request.user_agreement"
                    @input="request.user_agreement = $event"
                    placeholder="请输入用户协议"
                    style="min-height: 200px"
                ></Editor>
            </div>
        </div>
        <div class="uploadFile">
            <label>隐私政策:</label>
            <div>
                <Editor
                    :value="request.privacy_policy"
                    @input="request.privacy_policy = $event"
                    placeholder="请输入隐私政策"
                    style="min-height: 200px"
                ></Editor>
                <a-button type="primary" @click="submit" style="margin-top: 10px">保存</a-button>
            </div>
        </div>
    </div>
</template>
<script>
import { uploadImg } from '@/libs/api'
import { editSet, getSet } from '@/libs/examapi'
import Editor from '@/components/wangeditor'

export default {
    name: 'jySet',
    components:{ Editor },
    data(){
        return{
            fileList:[],
            imgList:[],
            vipImgList: [],
            loading: false,
            vipLoading: false,
            request:{
                notes: '',
                notes_name: '',
                detail_page: '',
                vip_detail_page: '',
                user_agreement: '',
                privacy_policy: ''
            }
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        getData(){
            getSet().then(res=>{
                let {detail_page, notes, notes_name, vip_detail_page, user_agreement, privacy_policy} = res
                this.fileList = [{
                    uid: '1',
                    name: notes_name,
                    status: 'done',
                    url: notes,
                }]
                this.vipImgList = vip_detail_page ? [{
                    uid: '2',
                    name: 'vip-detail.jpg',
                    status: 'done',
                    url: vip_detail_page,
                }] : [];
                
                Object.assign(this.request, {
                    detail_page,
                    notes,
                    vip_detail_page,
                    user_agreement,
                    privacy_policy
                })
                console.log(this.request)
            }).catch(error=>{
                console.log(error)
            })
        },
        handleChange(info){
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
            fileList = fileList.map(file => {
                if (file.response) {
                    file.url = file.response.url;
                }
            return file;
            });
            this.fileList = fileList;
            this.request.notes_name = fileList[0].name
        },
        customRequestDetail(data){
            let formData = new FormData()
            formData.append('file',data.file)
            uploadImg(formData).then(res=>{
               this.fileList[0].status='done'
               this.request.notes = res.fileUrl
               this.submit()
            },error=>{
                console.log(error)
            })
        },
        handleChangeImg(info){
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
            fileList = fileList.map(file => {
            if (file.response) {
                file.url = file.response.url;
            }
            return file;
            });
            this.imgList = fileList;
        },
        customRequest(data){
            let formData = new FormData()
            formData.append('file', data.file)
            uploadImg(formData).then(res=>{
                this.request.detail_page = res.fileUrl
                this.submit()
            },error=>{
                console.log(error)
            })
        },
        customVipDetailRequest(data) {
            this.vipLoading = true;
            let formData = new FormData()
            formData.append('file', data.file)
            uploadImg(formData).then(res => {
                this.request.vip_detail_page = res.fileUrl;
                this.vipLoading = false;
                this.submit();
            }).catch(error => {
                console.log(error);
                this.vipLoading = false;
            })
        },
        submit(){
            editSet({...this.request}).then(res=>{
                this.$message.success('保存成功')
            }).catch(error=>{
                console.log(error)
            })
        }
    }
}
</script>
<style lang="less" scoped>
.uploadFile{
    display: flex;
    padding: 30px 0 50px;
    label{
        width: 150px;
        line-height: 32px;
    }
}
</style>